"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_FAILURE = exports.UPDATE_SUCCESS = exports.UPDATE_REQUEST = void 0;
exports.UPDATE_REQUEST = 'plugins/UPDATE/REQUEST';
exports.UPDATE_SUCCESS = 'plugins/UPDATE/SUCCESS';
exports.UPDATE_FAILURE = 'plugins/UPDATE/FAILURE';
//# sourceMappingURL=types.js.map